import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getUserSession } from "../utils/userSession";

import Header from "../components/header";
import Footer from "../components/footer";

export default function Career() {
  const savedSession = getUserSession();
  const [fileName, setFileName] = useState("Upload Resume");

    const [formData, setFormData] = useState({
    name: savedSession?.name || "",
    email: savedSession?.email || "",
    phone: savedSession?.mobile || "",
    position: "",
    resume: null
  });

const handleChange = (e) => {
  const { name, value, files } = e.target;

  if (name === "resume") {
    const file = files[0];

    setFormData({
      ...formData,
      resume: file
    });

    setFileName(file ? file.name : "Upload Resume");

  } else {
    setFormData({
      ...formData,
      [name]: value
    });
  }
};
  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();

    data.append("name", formData.name);
    data.append("email", formData.email);
    data.append("phone", formData.phone);
    data.append("position", formData.position);
    data.append("resume", formData.resume);

    try {

      const response = await fetch("https://biomefarms.com/apiMail/career.php", {
        method: "POST",
        body: data
      });

      const result = await response.json();

      if (response.ok) {
        toast.success("Application Submitted Successfully!");

        setFormData({
          name: "",
          email: "",
          phone: "",
          position: "",
          resume: null
        });

      } else {
        toast.error("Submission Failed");
      }

    } catch (error) {
      toast.error("Server Error");
    }
  };


return(
    <div className="dody-container">
        <Header/>
         <section>
             <div className="biome biome-24 career-24">
                <ToastContainer/>
             <div className="biome-element biome-element-2e6e941 e-flex e-con-boxed e-con e-parent e-lazyloaded biome-contact ">
  <div className="biome-element biome-element-5c286c58 e-flex e-con-boxed e-con e-parent e-lazyloaded section-scroll-animation">
                <div className="e-con-inner justify-section-top">
                    <div
                        className="biome-element biome-element-47b1a33 e-con-full e-flex e-con e-child ">
                       
                        <div className="biome-element e-con-full e-flex e-con e-child  animate-section-trigger">
                            <div className="biome-element biome-widget biome-widget-text-editor animated fadeInUp">
                                <div className="biome-widget-container">
                                    <h1 data-anim="rotate"
                                        className="ekit-heading--title elementskit-section-title animation__char_come  gsap-text text-center attr-text-white">
                                       Grow Your Career
                                    </h1>
                                    <h3 data-anim="rotate"
                                        className="ekit-heading--title elementskit-section-title animation__char_come  gsap-text text-center attr-text-white">
                                       Join the Biome Revolution
                                    </h3>
                               
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

                <form className="e-con-inner section-scroll-animation justice-content-center" onSubmit={handleSubmit} encType="multipart/form-data">
                          <div className="biome-element biome-element-5620815 e-con-full e-flex e-con e-child animated ">
                        <div className="biome-element biome-element-1129d43 biome-widget biome-widget-metform ">
                            <div className="biome-widget-container">

                                <div id="mf-response-props-id-199" className="mf-scroll-top-no">
                                    <div className="formpicker_warper formpicker_warper_editable">

                                        <div className="mf-widget-container">

                                            <div id="metform-wrap-1129d43-199" className="mf-form-wrapper">
                                               
                                                <div className="metform-form-content">
                                                              <div className="metform-form-main-wrapper">
                                                        <div className="biome biome-199">
                                                            <div
                                                                className="biome-element biome-element-241aff9 e-flex e-con-boxed e-con e-parent">
                                                                <div className="e-con-inner">

                                                                    <div
                                                                        className="biome-element biome-element-d1da4a8 biome-widget biome-widget-mf-listing-fname">
                                                                        <div className="biome-widget-container">
                                                                            <div className="mf-input-wrapper">
                                                                                <label className="mf-input-label"
                                                                                    htmlFor="mf-input-text-d1da4a8">Your
                                                                                    Name <span
                                                                                        className="mf-input-required-indicator"></span></label>
                                                                                <input type="text" className="mf-input "
                                                                                  name="name"
                                                                                placeholder="Full Name"
                                                                                value={formData.name}
                                                                                onChange={handleChange}
                                                                                required
                                                                                    aria-invalid="false" />
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div
                                                                        className="biome-element biome-element-3f98bf9 biome-widget biome-widget-mf-email">
                                                                        <div className="biome-widget-container">
                                                                            <div className="mf-input-wrapper">
                                                                                <label className="mf-input-label"
                                                                                    htmlFor="mf-input-email-3f98bf9">Email
                                                                                    <span
                                                                                        className="mf-input-required-indicator"></span></label>
                                                                                <input type="email" className="mf-input "
                                                                                    placeholder="Email"
                                                                                    value={formData.email}
                                                                                    onChange={handleChange}
                                                                                    required
                                                                                    aria-invalid="false"/>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div
                                                                        className="biome-element biome-element-a4235a9 biome-widget biome-widget-mf-telephone">
                                                                        <div className="biome-widget-container">
                                                                            <div className="mf-input-wrapper">
                                                                                <label className="mf-input-label"
                                                                                    htmlFor="mf-input-telephone-a4235a9">Phone
                                                                                    <span
                                                                                        className="mf-input-required-indicator"></span></label>
                                                                                <input className="mf-input "
                                                                                    type="text"
                                                                                    name="phone"
                                                                                    placeholder="Phone Number"
                                                                                    value={formData.phone}
                                                                                    onChange={handleChange}
                                                                                    required
                                                                                    aria-invalid="false" />
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                 <div
                                                                        className="biome-element biome-element-a4235a9 biome-widget biome-widget-mf-telephone">
                                                                        <div className="biome-widget-container">
                                                                            <div className="mf-input-wrapper">
                                                                                <label className="mf-input-label" htmlFor="mf-input-telephone-a4235a9">.pdf,.doc,.docx
                                                                                    <span className="mf-input-required-indicator"></span>
                                                                                </label>
                                                                              
                                                                                <label className="mf-input upload-btn">
                                                                                {fileName}
                                                                                <input
                                                                                    type="file"
                                                                                    name="resume"
                                                                                    className="mf-input "
                                                                                    accept=".pdf,.doc,.docx"
                                                                                    onChange={handleChange}
                                                                                    style={{ display: "none" }}
                                                                                />
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                   

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                               
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="biome-element biome-element-1129d43 biome-widget biome-widget-metform ">
                            <div className="biome-widget-container">

                                <div id="mf-response-props-id-199" className="mf-scroll-top-no">
                                    <div className="formpicker_warper formpicker_warper_editable">

                                        <div className="mf-widget-container">

                                            <div id="metform-wrap-1129d43-199" className="mf-form-wrapper">
                                               
                                                <div className="metform-form-content">
                                                              <div className="metform-form-main-wrapper">
                                                        <div className="biome biome-199">
                                                            <div
                                                                className="biome-element biome-element-241aff9 e-flex e-con-boxed e-con e-parent">
                                                                <div className="e-con-inner">

                                                               
                                                                  

                                                                    <div
                                                                        className="biome-element biome-element-a429567 biome-widget biome-widget-mf-textarea">
                                                                        <div className="biome-widget-container">
                                                                            <div className="mf-input-wrapper">
                                                                                <label className="mf-input-label"
                                                                                    htmlFor="mf-input-text-area-a429567">Your
                                                                                    Message <span
                                                                                        className="mf-input-required-indicator"></span></label>
                                                                                <textarea className="mf-input mf-textarea "
                                                                                    id="mf-input-text-area-a429567"
                                                                                    name="mf-textarea"
                                                                                    placeholder="Your message here " cols={30}
                                                                                    rows={10} aria-invalid="false"></textarea>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div
                                                                        className="biome-element biome-element-e828f1d mf-btn--justify mf-btn--justify-left mf-btn--tablet-justify mf-btn--mobile-justify biome-widget biome-widget-mf-button">
                                                                        <div className="biome-widget-container">
                                                                            <div className="mf-btn-wraper "
                                                                                data-mf-form-conditional-logic-requirement="">
                                                                                <button type="submit"
                                                                                    className="metform-btn metform-submit-btn "><span>Apply Now </span></button>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                               
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>


            </div>
  </div>
         </section>
         <Footer/>
    </div>
 
)
} 